import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=ec7bd996&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"
import style0 from "./Photo.vue?vue&type=style&index=0&id=ec7bd996&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7bd996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec7bd996')) {
      api.createRecord('ec7bd996', component.options)
    } else {
      api.reload('ec7bd996', component.options)
    }
    module.hot.accept("./Photo.vue?vue&type=template&id=ec7bd996&scoped=true", function () {
      api.rerender('ec7bd996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/folder/Photo.vue"
export default component.exports